import { baseClient, API } from "../index";
import { intl } from "../../translations/I18nProvider";

/**
 * Convierte errores de axios al cargar partida (p. ej. 404) en mensaje legible.
 * @param {unknown} err
 * @param {'id'|'code'} kind — partida por id Mongo vs por código de 6 dígitos
 * @returns {string} mensaje para mostrar al usuario; cadena vacía si no aplica sustitución
 */
export function formatGameLoadError(err, kind = "id") {
	const status = err?.response?.status;
	const serverMsg = String(err?.response?.data?.message || "").trim();
	if (serverMsg) return serverMsg;
	const notFound =
		kind === "code"
			? intl.formatMessage({ id: "ENTER_CODE.ERROR_NOT_FOUND" })
			: intl.formatMessage({ id: "ENTER_CODE.ERROR_GAME_NOT_FOUND" });
	if (status === 404) return notFound;
	const raw = String(err?.message || "");
	if (/^Request failed with status code\b/i.test(raw)) return notFound;
	return "";
}

export const getGameById = async (id) => {
	return baseClient().get(`${API}/game/${id}`);
};

export const getGameByCode = async (code) => {
	return baseClient().get(`${API}/game/by-code/${encodeURIComponent(String(code || "").trim())}`);
};

export const getAvailableTableByGameId = async (id) => {
	return baseClient().get(`${API}/game/${id}/available-table`);
};
